var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.theAttr.name))]),_c('td',[_c('button',{staticClass:"purple-btn ml-2",on:{"click":_vm.edit}},[_vm._v("ویرایش")]),_c('button',{staticClass:"purple-btn",on:{"click":_vm.remove}},[_vm._v("حذف")])])])}
var staticRenderFns = []

export { render, staticRenderFns }